// extracted by mini-css-extract-plugin
export default {"description":"style_description__fa-RJ","fade-in":"style_fade-in__wZRen","top":"style_top__QwEDX","image":"style_image__aZkWk"};